import { API_BASE_URL } from '@/services/api-service';

export type ApiEnvironment = 'production' | 'preview';

export interface ApiEnvironmentInfo {
	environment: ApiEnvironment;
	isPreview: boolean;
	apiBaseUrl: string;
	apiHostname: string | null;
}

const normalize = (value: string): string => value.trim();

export const getApiHostname = (apiBaseUrl: string): string | null => {
	let rest = normalize(apiBaseUrl);
	if (!rest) return null;

	// Strip protocol (e.g., https://, http://)
	const protocolIdx = rest.indexOf('://');
	if (protocolIdx !== -1) {
		rest = rest.slice(protocolIdx + 3);
	}

	// Strip leading slashes (e.g., //localhost:8887/)
	while (rest.startsWith('/')) {
		rest = rest.slice(1);
	}
	if (!rest) return null;

	// Host is everything up to the next / ? #
	const endIdx = rest.search(/[/?#]/);
	const hostPortRaw = (endIdx === -1 ? rest : rest.slice(0, endIdx)).toLowerCase();
	if (!hostPortRaw) return null;

	// Strip credentials (user:pass@host)
	const atIdx = hostPortRaw.lastIndexOf('@');
	const hostPort = atIdx !== -1 ? hostPortRaw.slice(atIdx + 1) : hostPortRaw;

	// IPv6 in brackets: [::1]:8887
	if (hostPort.startsWith('[')) {
		const bracketEnd = hostPort.indexOf(']');
		if (bracketEnd !== -1) {
			return hostPort.slice(1, bracketEnd) || null;
		}
	}

	// Strip port
	const colonIdx = hostPort.indexOf(':');
	const host = colonIdx !== -1 ? hostPort.slice(0, colonIdx) : hostPort;
	return host || null;
};

export const isPreviewApiBaseUrl = (apiBaseUrl: string): boolean => {
	const host = getApiHostname(apiBaseUrl);
	const value = host ?? normalize(apiBaseUrl).toLowerCase();
	if (!value) return false;

	if (value === 'localhost' || value === '127.0.0.1' || value === '::1') {
		return true;
	}

	return value.startsWith('test-');
};

export const getApiEnvironmentInfo = (apiBaseUrl: string): ApiEnvironmentInfo => {
	const apiHostname = getApiHostname(apiBaseUrl);
	const isPreview = isPreviewApiBaseUrl(apiBaseUrl);

	return {
		environment: isPreview ? 'preview' : 'production',
		isPreview,
		apiBaseUrl,
		apiHostname,
	};
};

export const apiEnvironment = getApiEnvironmentInfo(API_BASE_URL);


